import CropModal from './CropModal';

export default CropModal;
